import { c as _c } from "react/compiler-runtime";
import React from "react";
interface FormSectionProps {
  readonly title: string;
  readonly children: React.ReactNode;
  readonly titleClassName?: string | undefined;
  readonly contentClassName?: string | undefined;
  readonly headerRight?: React.ReactNode;
}

/**
 * FormSection - A reusable component for creating form sections with titles
 *
 * This component allows customizing the styling of the section, title,
 * and content areas through className props.
 */
const FormSection: React.FC<FormSectionProps> = t0 => {
  const $ = _c(14);
  const {
    title,
    children,
    titleClassName: t1,
    contentClassName: t2,
    headerRight
  } = t0;
  const titleClassName = t1 === undefined ? "tw-text-base tw-font-semibold tw-tracking-tight tw-text-iron-100" : t1;
  const contentClassName = t2 === undefined ? "" : t2;
  let t3;
  if ($[0] !== title || $[1] !== titleClassName) {
    t3 = <div className={titleClassName}>{title}</div>;
    $[0] = title;
    $[1] = titleClassName;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== headerRight) {
    t4 = headerRight !== undefined && <div>{headerRight}</div>;
    $[3] = headerRight;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between">{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children || $[9] !== contentClassName) {
    t6 = <div className={contentClassName}>{children}</div>;
    $[8] = children;
    $[9] = contentClassName;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default FormSection;